import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import { clamp } from '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import Button from '../Button/index.esm.js';
import IconButton from '../IconButton/index.esm.js';
import ButtonGroup from '../ButtonGroup/index.esm.js';

var getButtons = function getButtons(page, pageCount, onChange) {
  var limit = 5;
  var middle = Math.ceil(limit / 2);
  var offset = 0;

  if (pageCount > limit) {
    if (page < limit) {
      offset = 0;
    } else {
      var max = pageCount - limit;
      offset = clamp(page > max ? max : page - middle, 0, max);
    }
  }

  var items = Array.from(Array(clamp(pageCount, 0, limit))).map(function (value, index) {
    return Number(index) + offset;
  });

  if (pageCount > limit) {
    // Add the 1 ...
    if (offset > 1) {
      items.unshift(0, null);
    } // Add the ... last


    var lastIndex = pageCount - 1;

    if (!items.includes(lastIndex) && pageCount > limit + 2) {
      items.push(null, lastIndex);
    }
  }

  return items.map(function (item, index) {
    if (item === null) {
      return React__default.createElement(Box, {
        as: "span",
        key: "spacer-" + index,
        padding: ['px-2', 'py-2'],
        borderWidth: "border",
        borderColor: "border-gray-200",
        backgroundColor: "bg-gray-50",
        userSelect: "select-none"
      }, "\u2026");
    }

    var number = item + 1;
    var active = number === page;
    return React__default.createElement(Button, {
      key: item,
      appearance: active ? 'primary' : undefined,
      "aria-current": active ? 'page' : undefined,
      "aria-label": "Page " + number + (active ? ', current page' : ''),
      onClick: function onClick() {
        return onChange && onChange(number);
      }
    }, number);
  });
};

var Pagination = function Pagination(props) {
  var totalResults = props.totalResults,
      pageSize = props.pageSize,
      page = props.page,
      onChange = props.onChange,
      _props$compact = props.compact,
      compact = _props$compact === void 0 ? false : _props$compact,
      rest = _objectWithoutPropertiesLoose(props, ["totalResults", "pageSize", "page", "onChange", "compact"]);

  var pageCount = props.pageCount;

  if (!totalResults || !pageSize) {
    return null;
  }

  if (!pageCount) {
    pageCount = Math.ceil(totalResults / pageSize);
  }

  if (!pageCount || pageCount <= 1) {
    return null;
  }

  var hasPrevious = page > 1;
  var hasNext = page < pageCount;

  var changeHandler = function changeHandler(target) {
    if (target === page) {
      return;
    }

    onChange(clamp(target, 1, pageCount));
  };

  return React__default.createElement(ButtonGroup, _extends({
    as: "nav",
    "aria-label": "Pagination",
    attached: true
  }, rest), React__default.createElement(IconButton, {
    disabled: !hasPrevious,
    onClick: function onClick() {
      return hasPrevious ? changeHandler(page - 1) : {};
    },
    icon: "chevron-left",
    label: "Previous"
  }), compact ? React__default.createElement(Box, {
    as: "span",
    padding: ['px-4', 'py-2'],
    backgroundColor: "bg-white",
    borderWidth: "border",
    borderColor: "border-gray-200",
    borderStyle: "border-solid",
    borderRadius: "rounded-none",
    userSelect: "select-none",
    key: "status"
  }, page, React__default.createElement(Box, {
    as: "span",
    textColor: "text-gray-400"
  }, " / " + pageCount)) : getButtons(page, pageCount, changeHandler), React__default.createElement(IconButton, {
    disabled: !hasNext,
    onClick: function onClick() {
      return hasNext ? changeHandler(page + 1) : {};
    },
    icon: "chevron-right",
    label: "Next"
  }));
};

export default Pagination;
//# sourceMappingURL=index.esm.js.map
